import {
  ru,
  format,
  isSameYear,
  isSameDay,
  subDays,
} from 'core/libs/date-fns';


/**
 * Форматирует дату в соответствии с переданным шаблоном.
 * @param {string|number} rawDate - дата в формате, поддерживаемом конструктором new Date().
 * @returns {string}
 */
export function dateFormat(rawDate, pattern) {
  return format(new Date(rawDate), pattern, { locale: ru });
}

/**
 * Форматирует дату в полную для отображения в топиках и на AMP странице.
 * @param {string|number} rawDate - дата в формате, поддерживаемом конструктором new Date().
 * @returns {string}
 */
export function topicFullDateFormat(rawDate) {
  const date = new Date(rawDate);
  const pattern = 'dd MMMM y, HH:mm';

  return format(date, pattern, { locale: ru });
}

/**
 * Форматирует дату для отображения в топиках.
 * @param {string|number} rawDate - дата в формате, поддерживаемом конструктором new Date().
 * @returns {string}
 */
export function topicDateFormat(rawDate) {
  const date = new Date(rawDate);
  const now = Date.now();

  let pattern = 'dd MMMM yyyy, HH:mm';

  if (isSameDay(date, now)) {
    pattern = 'Сегодня в HH:mm';
  } else if (isSameDay(date, subDays(now, 1))) {
    pattern = 'Вчера в HH:mm';
  } else if (isSameYear(date, now)) {
    pattern = 'dd MMMM, HH:mm';
  }

  return format(date, pattern, { locale: ru });
}


/**
 * Возвращает отформатированную дату, приведенную к московскому времени.
 * Дата изменяется, путем прибавления трех часов к исходной дате в UTC.
 * Поэтому в pattern не нужно пытаться вывести смещение - оно будет зависеть
 * от часовго пояса.
 * @returns {string}
 */
export function formatToMoscowTimeZone(isoDate, pattern = "yyyy-MM-dd'T'HH:mm:ss'+03:00") {
  const date = new Date(isoDate);

  const utcDate = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours() + 3,
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );

  return dateFormat(utcDate, pattern);
}

export function timeDurationInSeconds(isoDuration) {
  const iso8601DurationRegex = /(-)?T(?:([.,\d]+)S)?/;

  const matches = isoDuration.match(iso8601DurationRegex);

  return (!matches || !matches[2]) ? 0 : Number(matches[2]);
}


/**
 * Проверяет валидность даты в объекте Date
 *
 * @param {object} date объект Date
 * @returns {boolean}
 */
export function isDateValid(date) {
  return Boolean(date instanceof Date && date.valueOf());
}
